import { CreateUser } from "./pages/createUser";
import { WantToAchive } from "./pages/want-to-achive";
import { steps, CREATE_USER, WANT_TO_ACHIVE } from "./steps";

export const renderSteps = (step = steps[0].id) => {
  switch (step) {
    case CREATE_USER:
      return <CreateUser />;
    case WANT_TO_ACHIVE:
    default:
      return <WantToAchive step={step} />;
  }
};
